/* eslint-disable camelcase */
export default class RGA {
  id = 0;
  rga_no = '';
  sales_order = {
    partner_id: 0,
    partner_store_id: 0,
    order_no: '',
    customer_purchase_order: '',
    partner_store: {}
  };
  sales_order_id = 0;
  sequence = 0;
  memo = '';
  created_at = '';
  updated_at = '';
  expected_return_date = '';
  tax_code = '';
  created_by_name = '';
  restock_fee_percentage = '';
  is_memo_required = '';
  allowed_item_master_ids = {};

  constructor (data) {
    Object.assign(this, data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/RGA.js